/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Devices_Col_Received_AtInputs */

const vi_irrigation_devices_col_received_at = /** @type {(inputs: Irrigation_Devices_Col_Received_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cập nhật lúc`)
};

/**

* @param {Irrigation_Devices_Col_Received_AtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_devices_col_received_at = /** @type {((inputs?: Irrigation_Devices_Col_Received_AtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Devices_Col_Received_AtInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_devices_col_received_at(inputs)
});